import { HexColor } from '@/shared/models/common';

export interface CompetenceId {__competenceId: number}

export default class Competence {
  id: CompetenceId | null = null;
  description = '';
  colorHex: HexColor = 'fff0';
}
